function parseOfferDate(dateStr: string) {
    const match = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?/.exec(dateStr);

    if (!match) {
        return undefined;
    }

    return {
        year: Number(match[1]),
        month: Number(match[2]),
        day: Number(match[3]),
        hours: match[4] === undefined ? undefined : Number(match[4]),
        minutes: match[5] === undefined ? undefined : Number(match[5]),
    };
}

function formatDate(year: number, month: number, day: number): string {
    return new Intl.DateTimeFormat('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC',
    }).format(new Date(Date.UTC(year, month - 1, day)));
}

function formatHour(hours: number, minutes: number): { hour: string; period: string } {
    const period = hours >= 12 ? 'pm' : 'am';
    const hour12 = hours % 12 || 12;
    const hour = minutes === 0 ? `${hour12}` : `${hour12}:${String(minutes).padStart(2, '0')}`;

    return { hour, period };
}

export function formatStoreEventSchedule(availabilityStart?: string, availabilityEnd?: string): string {
    if (!availabilityStart) {
        return '';
    }

    const start = parseOfferDate(availabilityStart);

    if (!start) {
        return '';
    }

    const end = availabilityEnd ? parseOfferDate(availabilityEnd) : undefined;

    if (end && (end.year !== start.year || end.month !== start.month || end.day !== start.day)) {
        return `${formatDate(start.year, start.month, start.day)} – ${formatDate(end.year, end.month, end.day)}`;
    }

    const datePart = formatDate(start.year, start.month, start.day);

    if (start.hours != null && end?.hours != null && start.minutes != null && end.minutes != null) {
        const startTime = formatHour(start.hours, start.minutes);
        const endTime = formatHour(end.hours, end.minutes);
        const times =
            startTime.period === endTime.period
                ? `${startTime.hour}-${endTime.hour} ${endTime.period}`
                : `${startTime.hour} ${startTime.period}-${endTime.hour} ${endTime.period}`;

        return `${datePart} • ${times}`;
    }

    if (start.hours != null && start.minutes != null && (start.hours !== 0 || start.minutes !== 0)) {
        const { hour, period } = formatHour(start.hours, start.minutes);

        return `${datePart} • ${hour} ${period}`;
    }

    return datePart;
}
